<template>

  <div class="uk-width-1-4@m">
    <button @click="handleSubmit" class="uk-button uk-button-primary uk-align-right">{{ $t('frontend-mtg.area_riservata.ordini.export') }}</button>
  </div>

</template>

<script>
export default {
  methods: {
    handleSubmit() {
      const checkboxes = document.querySelectorAll('input[type="checkbox"][name="order"]');
      const selectedValues = [];
      checkboxes.forEach((checkbox) => {
        if (checkbox.checked) {
          selectedValues.push(checkbox.value);
        }
      });
      window.location.href = `/export-orders?values=`+selectedValues.join(';');
    }
  }
}
</script>



// WEBPACK FOOTER //
// public/themes/frontend/mtg/extensions/rubinred/collections/assets/js/OrdersExport.vue